import AbstractService from '@/services/abstractService'

class SettingsService extends AbstractService {
  endpoint = 'params'

  index() {
    return this.http.get(this.endpoint)
  }

  post(data) {
    console.log('data', data)
    // define append form
    const form_data = new FormData()
    for (const key in data) {
      form_data.append(key, data[key])
    }
    return this.http.post(this.endpoint, form_data)
  }

  put(data) {
    console.log('data', data)
    console.log('type===>', typeof (data.image))
    // define append form
    const formData = new FormData()

    for (const key in data) {
      formData.append(key, data[key])
    }
    return this.http.put(`${this.endpoint}/${data.id}`, formData)
  }

  delete(data) {
    console.log('data', data)
    return this.http.delete(`${this.endpoint}/${data}`)
  }
}

const Service = new SettingsService()

export default Service
